module.exports = __webpack_public_path__ + "assets/img/e4b69e8887739949eabcb1bf01e4211e.svg";